import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/hotelInfo', request)
}

async function post(request) {
    return await postMethod('/api/hotelInfo', request)
}

async function put(request) {
    const {hotelId} = request
    return await putMethod(`/api/hotelInfo?hotelId=${hotelId}`, request)
}

export {get, post, put}
